module.exports = "<img [src]=\"source\" alt=\"Image\" class=\"responsive\">\r\n"